/**
 * ApiGest API
 * ApiGest API documentation
 *
 * OpenAPI spec version: 1.0.0
 * Contact: info@eneasys.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ContextGroupDTO } from '../model/contextGroupDTO';

import { AIG_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ContextGroupResourceService {

    protected basePath = 'https://api-gest.eneasys.net';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(AIG_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * countContextGroups
     * 
     * @param groupMemberOfIdEquals 
     * @param groupMemberOfIdGreaterThan 
     * @param groupMemberOfIdGreaterThanOrEqual 
     * @param groupMemberOfIdIn 
     * @param groupMemberOfIdLessThan 
     * @param groupMemberOfIdLessThanOrEqual 
     * @param groupMemberOfIdNotEquals 
     * @param groupMemberOfIdSpecified 
     * @param groupMembersIdEquals 
     * @param groupMembersIdGreaterThan 
     * @param groupMembersIdGreaterThanOrEqual 
     * @param groupMembersIdIn 
     * @param groupMembersIdLessThan 
     * @param groupMembersIdLessThanOrEqual 
     * @param groupMembersIdNotEquals 
     * @param groupMembersIdSpecified 
     * @param idEquals 
     * @param idGreaterThan 
     * @param idGreaterThanOrEqual 
     * @param idIn 
     * @param idLessThan 
     * @param idLessThanOrEqual 
     * @param idNotEquals 
     * @param idSpecified 
     * @param nameContains 
     * @param nameDoesNotContain 
     * @param nameEquals 
     * @param nameIn 
     * @param nameNotEquals 
     * @param nameSpecified 
     * @param userMembersIdEquals 
     * @param userMembersIdGreaterThan 
     * @param userMembersIdGreaterThanOrEqual 
     * @param userMembersIdIn 
     * @param userMembersIdLessThan 
     * @param userMembersIdLessThanOrEqual 
     * @param userMembersIdNotEquals 
     * @param userMembersIdSpecified 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public countContextGroupsUsingGET(groupMemberOfIdEquals?: number, groupMemberOfIdGreaterThan?: number, groupMemberOfIdGreaterThanOrEqual?: number, groupMemberOfIdIn?: Array<number>, groupMemberOfIdLessThan?: number, groupMemberOfIdLessThanOrEqual?: number, groupMemberOfIdNotEquals?: number, groupMemberOfIdSpecified?: boolean, groupMembersIdEquals?: number, groupMembersIdGreaterThan?: number, groupMembersIdGreaterThanOrEqual?: number, groupMembersIdIn?: Array<number>, groupMembersIdLessThan?: number, groupMembersIdLessThanOrEqual?: number, groupMembersIdNotEquals?: number, groupMembersIdSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, nameContains?: string, nameDoesNotContain?: string, nameEquals?: string, nameIn?: Array<string>, nameNotEquals?: string, nameSpecified?: boolean, userMembersIdEquals?: number, userMembersIdGreaterThan?: number, userMembersIdGreaterThanOrEqual?: number, userMembersIdIn?: Array<number>, userMembersIdLessThan?: number, userMembersIdLessThanOrEqual?: number, userMembersIdNotEquals?: number, userMembersIdSpecified?: boolean, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public countContextGroupsUsingGET(groupMemberOfIdEquals?: number, groupMemberOfIdGreaterThan?: number, groupMemberOfIdGreaterThanOrEqual?: number, groupMemberOfIdIn?: Array<number>, groupMemberOfIdLessThan?: number, groupMemberOfIdLessThanOrEqual?: number, groupMemberOfIdNotEquals?: number, groupMemberOfIdSpecified?: boolean, groupMembersIdEquals?: number, groupMembersIdGreaterThan?: number, groupMembersIdGreaterThanOrEqual?: number, groupMembersIdIn?: Array<number>, groupMembersIdLessThan?: number, groupMembersIdLessThanOrEqual?: number, groupMembersIdNotEquals?: number, groupMembersIdSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, nameContains?: string, nameDoesNotContain?: string, nameEquals?: string, nameIn?: Array<string>, nameNotEquals?: string, nameSpecified?: boolean, userMembersIdEquals?: number, userMembersIdGreaterThan?: number, userMembersIdGreaterThanOrEqual?: number, userMembersIdIn?: Array<number>, userMembersIdLessThan?: number, userMembersIdLessThanOrEqual?: number, userMembersIdNotEquals?: number, userMembersIdSpecified?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public countContextGroupsUsingGET(groupMemberOfIdEquals?: number, groupMemberOfIdGreaterThan?: number, groupMemberOfIdGreaterThanOrEqual?: number, groupMemberOfIdIn?: Array<number>, groupMemberOfIdLessThan?: number, groupMemberOfIdLessThanOrEqual?: number, groupMemberOfIdNotEquals?: number, groupMemberOfIdSpecified?: boolean, groupMembersIdEquals?: number, groupMembersIdGreaterThan?: number, groupMembersIdGreaterThanOrEqual?: number, groupMembersIdIn?: Array<number>, groupMembersIdLessThan?: number, groupMembersIdLessThanOrEqual?: number, groupMembersIdNotEquals?: number, groupMembersIdSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, nameContains?: string, nameDoesNotContain?: string, nameEquals?: string, nameIn?: Array<string>, nameNotEquals?: string, nameSpecified?: boolean, userMembersIdEquals?: number, userMembersIdGreaterThan?: number, userMembersIdGreaterThanOrEqual?: number, userMembersIdIn?: Array<number>, userMembersIdLessThan?: number, userMembersIdLessThanOrEqual?: number, userMembersIdNotEquals?: number, userMembersIdSpecified?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public countContextGroupsUsingGET(groupMemberOfIdEquals?: number, groupMemberOfIdGreaterThan?: number, groupMemberOfIdGreaterThanOrEqual?: number, groupMemberOfIdIn?: Array<number>, groupMemberOfIdLessThan?: number, groupMemberOfIdLessThanOrEqual?: number, groupMemberOfIdNotEquals?: number, groupMemberOfIdSpecified?: boolean, groupMembersIdEquals?: number, groupMembersIdGreaterThan?: number, groupMembersIdGreaterThanOrEqual?: number, groupMembersIdIn?: Array<number>, groupMembersIdLessThan?: number, groupMembersIdLessThanOrEqual?: number, groupMembersIdNotEquals?: number, groupMembersIdSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, nameContains?: string, nameDoesNotContain?: string, nameEquals?: string, nameIn?: Array<string>, nameNotEquals?: string, nameSpecified?: boolean, userMembersIdEquals?: number, userMembersIdGreaterThan?: number, userMembersIdGreaterThanOrEqual?: number, userMembersIdIn?: Array<number>, userMembersIdLessThan?: number, userMembersIdLessThanOrEqual?: number, userMembersIdNotEquals?: number, userMembersIdSpecified?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {







































        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (groupMemberOfIdEquals !== undefined && groupMemberOfIdEquals !== null) {
            queryParameters = queryParameters.set('groupMemberOfId.equals', <any>groupMemberOfIdEquals);
        }
        if (groupMemberOfIdGreaterThan !== undefined && groupMemberOfIdGreaterThan !== null) {
            queryParameters = queryParameters.set('groupMemberOfId.greaterThan', <any>groupMemberOfIdGreaterThan);
        }
        if (groupMemberOfIdGreaterThanOrEqual !== undefined && groupMemberOfIdGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('groupMemberOfId.greaterThanOrEqual', <any>groupMemberOfIdGreaterThanOrEqual);
        }
        if (groupMemberOfIdIn) {
            groupMemberOfIdIn.forEach((element) => {
                queryParameters = queryParameters.append('groupMemberOfId.in', <any>element);
            })
        }
        if (groupMemberOfIdLessThan !== undefined && groupMemberOfIdLessThan !== null) {
            queryParameters = queryParameters.set('groupMemberOfId.lessThan', <any>groupMemberOfIdLessThan);
        }
        if (groupMemberOfIdLessThanOrEqual !== undefined && groupMemberOfIdLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('groupMemberOfId.lessThanOrEqual', <any>groupMemberOfIdLessThanOrEqual);
        }
        if (groupMemberOfIdNotEquals !== undefined && groupMemberOfIdNotEquals !== null) {
            queryParameters = queryParameters.set('groupMemberOfId.notEquals', <any>groupMemberOfIdNotEquals);
        }
        if (groupMemberOfIdSpecified !== undefined && groupMemberOfIdSpecified !== null) {
            queryParameters = queryParameters.set('groupMemberOfId.specified', <any>groupMemberOfIdSpecified);
        }
        if (groupMembersIdEquals !== undefined && groupMembersIdEquals !== null) {
            queryParameters = queryParameters.set('groupMembersId.equals', <any>groupMembersIdEquals);
        }
        if (groupMembersIdGreaterThan !== undefined && groupMembersIdGreaterThan !== null) {
            queryParameters = queryParameters.set('groupMembersId.greaterThan', <any>groupMembersIdGreaterThan);
        }
        if (groupMembersIdGreaterThanOrEqual !== undefined && groupMembersIdGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('groupMembersId.greaterThanOrEqual', <any>groupMembersIdGreaterThanOrEqual);
        }
        if (groupMembersIdIn) {
            groupMembersIdIn.forEach((element) => {
                queryParameters = queryParameters.append('groupMembersId.in', <any>element);
            })
        }
        if (groupMembersIdLessThan !== undefined && groupMembersIdLessThan !== null) {
            queryParameters = queryParameters.set('groupMembersId.lessThan', <any>groupMembersIdLessThan);
        }
        if (groupMembersIdLessThanOrEqual !== undefined && groupMembersIdLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('groupMembersId.lessThanOrEqual', <any>groupMembersIdLessThanOrEqual);
        }
        if (groupMembersIdNotEquals !== undefined && groupMembersIdNotEquals !== null) {
            queryParameters = queryParameters.set('groupMembersId.notEquals', <any>groupMembersIdNotEquals);
        }
        if (groupMembersIdSpecified !== undefined && groupMembersIdSpecified !== null) {
            queryParameters = queryParameters.set('groupMembersId.specified', <any>groupMembersIdSpecified);
        }
        if (idEquals !== undefined && idEquals !== null) {
            queryParameters = queryParameters.set('id.equals', <any>idEquals);
        }
        if (idGreaterThan !== undefined && idGreaterThan !== null) {
            queryParameters = queryParameters.set('id.greaterThan', <any>idGreaterThan);
        }
        if (idGreaterThanOrEqual !== undefined && idGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('id.greaterThanOrEqual', <any>idGreaterThanOrEqual);
        }
        if (idIn) {
            idIn.forEach((element) => {
                queryParameters = queryParameters.append('id.in', <any>element);
            })
        }
        if (idLessThan !== undefined && idLessThan !== null) {
            queryParameters = queryParameters.set('id.lessThan', <any>idLessThan);
        }
        if (idLessThanOrEqual !== undefined && idLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('id.lessThanOrEqual', <any>idLessThanOrEqual);
        }
        if (idNotEquals !== undefined && idNotEquals !== null) {
            queryParameters = queryParameters.set('id.notEquals', <any>idNotEquals);
        }
        if (idSpecified !== undefined && idSpecified !== null) {
            queryParameters = queryParameters.set('id.specified', <any>idSpecified);
        }
        if (nameContains !== undefined && nameContains !== null) {
            queryParameters = queryParameters.set('name.contains', <any>nameContains);
        }
        if (nameDoesNotContain !== undefined && nameDoesNotContain !== null) {
            queryParameters = queryParameters.set('name.doesNotContain', <any>nameDoesNotContain);
        }
        if (nameEquals !== undefined && nameEquals !== null) {
            queryParameters = queryParameters.set('name.equals', <any>nameEquals);
        }
        if (nameIn) {
            nameIn.forEach((element) => {
                queryParameters = queryParameters.append('name.in', <any>element);
            })
        }
        if (nameNotEquals !== undefined && nameNotEquals !== null) {
            queryParameters = queryParameters.set('name.notEquals', <any>nameNotEquals);
        }
        if (nameSpecified !== undefined && nameSpecified !== null) {
            queryParameters = queryParameters.set('name.specified', <any>nameSpecified);
        }
        if (userMembersIdEquals !== undefined && userMembersIdEquals !== null) {
            queryParameters = queryParameters.set('userMembersId.equals', <any>userMembersIdEquals);
        }
        if (userMembersIdGreaterThan !== undefined && userMembersIdGreaterThan !== null) {
            queryParameters = queryParameters.set('userMembersId.greaterThan', <any>userMembersIdGreaterThan);
        }
        if (userMembersIdGreaterThanOrEqual !== undefined && userMembersIdGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('userMembersId.greaterThanOrEqual', <any>userMembersIdGreaterThanOrEqual);
        }
        if (userMembersIdIn) {
            userMembersIdIn.forEach((element) => {
                queryParameters = queryParameters.append('userMembersId.in', <any>element);
            })
        }
        if (userMembersIdLessThan !== undefined && userMembersIdLessThan !== null) {
            queryParameters = queryParameters.set('userMembersId.lessThan', <any>userMembersIdLessThan);
        }
        if (userMembersIdLessThanOrEqual !== undefined && userMembersIdLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('userMembersId.lessThanOrEqual', <any>userMembersIdLessThanOrEqual);
        }
        if (userMembersIdNotEquals !== undefined && userMembersIdNotEquals !== null) {
            queryParameters = queryParameters.set('userMembersId.notEquals', <any>userMembersIdNotEquals);
        }
        if (userMembersIdSpecified !== undefined && userMembersIdSpecified !== null) {
            queryParameters = queryParameters.set('userMembersId.specified', <any>userMembersIdSpecified);
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<number>('get',`${this.basePath}/api/context-groups/count`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * createContextGroup
     * 
     * @param body contextGroupDTO
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createContextGroupUsingPOST(body: ContextGroupDTO, observe?: 'body', reportProgress?: boolean): Observable<ContextGroupDTO>;
    public createContextGroupUsingPOST(body: ContextGroupDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ContextGroupDTO>>;
    public createContextGroupUsingPOST(body: ContextGroupDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ContextGroupDTO>>;
    public createContextGroupUsingPOST(body: ContextGroupDTO, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling createContextGroupUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ContextGroupDTO>('post',`${this.basePath}/api/context-groups`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * deleteContextGroup
     * 
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteContextGroupUsingDELETE(id: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteContextGroupUsingDELETE(id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteContextGroupUsingDELETE(id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteContextGroupUsingDELETE(id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteContextGroupUsingDELETE.');
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/api/context-groups/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getAllContextGroups
     * 
     * @param groupMemberOfIdEquals 
     * @param groupMemberOfIdGreaterThan 
     * @param groupMemberOfIdGreaterThanOrEqual 
     * @param groupMemberOfIdIn 
     * @param groupMemberOfIdLessThan 
     * @param groupMemberOfIdLessThanOrEqual 
     * @param groupMemberOfIdNotEquals 
     * @param groupMemberOfIdSpecified 
     * @param groupMembersIdEquals 
     * @param groupMembersIdGreaterThan 
     * @param groupMembersIdGreaterThanOrEqual 
     * @param groupMembersIdIn 
     * @param groupMembersIdLessThan 
     * @param groupMembersIdLessThanOrEqual 
     * @param groupMembersIdNotEquals 
     * @param groupMembersIdSpecified 
     * @param idEquals 
     * @param idGreaterThan 
     * @param idGreaterThanOrEqual 
     * @param idIn 
     * @param idLessThan 
     * @param idLessThanOrEqual 
     * @param idNotEquals 
     * @param idSpecified 
     * @param nameContains 
     * @param nameDoesNotContain 
     * @param nameEquals 
     * @param nameIn 
     * @param nameNotEquals 
     * @param nameSpecified 
     * @param page Page number of the requested page
     * @param size Size of a page
     * @param sort Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param userMembersIdEquals 
     * @param userMembersIdGreaterThan 
     * @param userMembersIdGreaterThanOrEqual 
     * @param userMembersIdIn 
     * @param userMembersIdLessThan 
     * @param userMembersIdLessThanOrEqual 
     * @param userMembersIdNotEquals 
     * @param userMembersIdSpecified 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllContextGroupsUsingGET(groupMemberOfIdEquals?: number, groupMemberOfIdGreaterThan?: number, groupMemberOfIdGreaterThanOrEqual?: number, groupMemberOfIdIn?: Array<number>, groupMemberOfIdLessThan?: number, groupMemberOfIdLessThanOrEqual?: number, groupMemberOfIdNotEquals?: number, groupMemberOfIdSpecified?: boolean, groupMembersIdEquals?: number, groupMembersIdGreaterThan?: number, groupMembersIdGreaterThanOrEqual?: number, groupMembersIdIn?: Array<number>, groupMembersIdLessThan?: number, groupMembersIdLessThanOrEqual?: number, groupMembersIdNotEquals?: number, groupMembersIdSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, nameContains?: string, nameDoesNotContain?: string, nameEquals?: string, nameIn?: Array<string>, nameNotEquals?: string, nameSpecified?: boolean, page?: number, size?: number, sort?: Array<string>, userMembersIdEquals?: number, userMembersIdGreaterThan?: number, userMembersIdGreaterThanOrEqual?: number, userMembersIdIn?: Array<number>, userMembersIdLessThan?: number, userMembersIdLessThanOrEqual?: number, userMembersIdNotEquals?: number, userMembersIdSpecified?: boolean, observe?: 'body', reportProgress?: boolean): Observable<Array<ContextGroupDTO>>;
    public getAllContextGroupsUsingGET(groupMemberOfIdEquals?: number, groupMemberOfIdGreaterThan?: number, groupMemberOfIdGreaterThanOrEqual?: number, groupMemberOfIdIn?: Array<number>, groupMemberOfIdLessThan?: number, groupMemberOfIdLessThanOrEqual?: number, groupMemberOfIdNotEquals?: number, groupMemberOfIdSpecified?: boolean, groupMembersIdEquals?: number, groupMembersIdGreaterThan?: number, groupMembersIdGreaterThanOrEqual?: number, groupMembersIdIn?: Array<number>, groupMembersIdLessThan?: number, groupMembersIdLessThanOrEqual?: number, groupMembersIdNotEquals?: number, groupMembersIdSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, nameContains?: string, nameDoesNotContain?: string, nameEquals?: string, nameIn?: Array<string>, nameNotEquals?: string, nameSpecified?: boolean, page?: number, size?: number, sort?: Array<string>, userMembersIdEquals?: number, userMembersIdGreaterThan?: number, userMembersIdGreaterThanOrEqual?: number, userMembersIdIn?: Array<number>, userMembersIdLessThan?: number, userMembersIdLessThanOrEqual?: number, userMembersIdNotEquals?: number, userMembersIdSpecified?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ContextGroupDTO>>>;
    public getAllContextGroupsUsingGET(groupMemberOfIdEquals?: number, groupMemberOfIdGreaterThan?: number, groupMemberOfIdGreaterThanOrEqual?: number, groupMemberOfIdIn?: Array<number>, groupMemberOfIdLessThan?: number, groupMemberOfIdLessThanOrEqual?: number, groupMemberOfIdNotEquals?: number, groupMemberOfIdSpecified?: boolean, groupMembersIdEquals?: number, groupMembersIdGreaterThan?: number, groupMembersIdGreaterThanOrEqual?: number, groupMembersIdIn?: Array<number>, groupMembersIdLessThan?: number, groupMembersIdLessThanOrEqual?: number, groupMembersIdNotEquals?: number, groupMembersIdSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, nameContains?: string, nameDoesNotContain?: string, nameEquals?: string, nameIn?: Array<string>, nameNotEquals?: string, nameSpecified?: boolean, page?: number, size?: number, sort?: Array<string>, userMembersIdEquals?: number, userMembersIdGreaterThan?: number, userMembersIdGreaterThanOrEqual?: number, userMembersIdIn?: Array<number>, userMembersIdLessThan?: number, userMembersIdLessThanOrEqual?: number, userMembersIdNotEquals?: number, userMembersIdSpecified?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ContextGroupDTO>>>;
    public getAllContextGroupsUsingGET(groupMemberOfIdEquals?: number, groupMemberOfIdGreaterThan?: number, groupMemberOfIdGreaterThanOrEqual?: number, groupMemberOfIdIn?: Array<number>, groupMemberOfIdLessThan?: number, groupMemberOfIdLessThanOrEqual?: number, groupMemberOfIdNotEquals?: number, groupMemberOfIdSpecified?: boolean, groupMembersIdEquals?: number, groupMembersIdGreaterThan?: number, groupMembersIdGreaterThanOrEqual?: number, groupMembersIdIn?: Array<number>, groupMembersIdLessThan?: number, groupMembersIdLessThanOrEqual?: number, groupMembersIdNotEquals?: number, groupMembersIdSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, nameContains?: string, nameDoesNotContain?: string, nameEquals?: string, nameIn?: Array<string>, nameNotEquals?: string, nameSpecified?: boolean, page?: number, size?: number, sort?: Array<string>, userMembersIdEquals?: number, userMembersIdGreaterThan?: number, userMembersIdGreaterThanOrEqual?: number, userMembersIdIn?: Array<number>, userMembersIdLessThan?: number, userMembersIdLessThanOrEqual?: number, userMembersIdNotEquals?: number, userMembersIdSpecified?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {










































        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (groupMemberOfIdEquals !== undefined && groupMemberOfIdEquals !== null) {
            queryParameters = queryParameters.set('groupMemberOfId.equals', <any>groupMemberOfIdEquals);
        }
        if (groupMemberOfIdGreaterThan !== undefined && groupMemberOfIdGreaterThan !== null) {
            queryParameters = queryParameters.set('groupMemberOfId.greaterThan', <any>groupMemberOfIdGreaterThan);
        }
        if (groupMemberOfIdGreaterThanOrEqual !== undefined && groupMemberOfIdGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('groupMemberOfId.greaterThanOrEqual', <any>groupMemberOfIdGreaterThanOrEqual);
        }
        if (groupMemberOfIdIn) {
            groupMemberOfIdIn.forEach((element) => {
                queryParameters = queryParameters.append('groupMemberOfId.in', <any>element);
            })
        }
        if (groupMemberOfIdLessThan !== undefined && groupMemberOfIdLessThan !== null) {
            queryParameters = queryParameters.set('groupMemberOfId.lessThan', <any>groupMemberOfIdLessThan);
        }
        if (groupMemberOfIdLessThanOrEqual !== undefined && groupMemberOfIdLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('groupMemberOfId.lessThanOrEqual', <any>groupMemberOfIdLessThanOrEqual);
        }
        if (groupMemberOfIdNotEquals !== undefined && groupMemberOfIdNotEquals !== null) {
            queryParameters = queryParameters.set('groupMemberOfId.notEquals', <any>groupMemberOfIdNotEquals);
        }
        if (groupMemberOfIdSpecified !== undefined && groupMemberOfIdSpecified !== null) {
            queryParameters = queryParameters.set('groupMemberOfId.specified', <any>groupMemberOfIdSpecified);
        }
        if (groupMembersIdEquals !== undefined && groupMembersIdEquals !== null) {
            queryParameters = queryParameters.set('groupMembersId.equals', <any>groupMembersIdEquals);
        }
        if (groupMembersIdGreaterThan !== undefined && groupMembersIdGreaterThan !== null) {
            queryParameters = queryParameters.set('groupMembersId.greaterThan', <any>groupMembersIdGreaterThan);
        }
        if (groupMembersIdGreaterThanOrEqual !== undefined && groupMembersIdGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('groupMembersId.greaterThanOrEqual', <any>groupMembersIdGreaterThanOrEqual);
        }
        if (groupMembersIdIn) {
            groupMembersIdIn.forEach((element) => {
                queryParameters = queryParameters.append('groupMembersId.in', <any>element);
            })
        }
        if (groupMembersIdLessThan !== undefined && groupMembersIdLessThan !== null) {
            queryParameters = queryParameters.set('groupMembersId.lessThan', <any>groupMembersIdLessThan);
        }
        if (groupMembersIdLessThanOrEqual !== undefined && groupMembersIdLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('groupMembersId.lessThanOrEqual', <any>groupMembersIdLessThanOrEqual);
        }
        if (groupMembersIdNotEquals !== undefined && groupMembersIdNotEquals !== null) {
            queryParameters = queryParameters.set('groupMembersId.notEquals', <any>groupMembersIdNotEquals);
        }
        if (groupMembersIdSpecified !== undefined && groupMembersIdSpecified !== null) {
            queryParameters = queryParameters.set('groupMembersId.specified', <any>groupMembersIdSpecified);
        }
        if (idEquals !== undefined && idEquals !== null) {
            queryParameters = queryParameters.set('id.equals', <any>idEquals);
        }
        if (idGreaterThan !== undefined && idGreaterThan !== null) {
            queryParameters = queryParameters.set('id.greaterThan', <any>idGreaterThan);
        }
        if (idGreaterThanOrEqual !== undefined && idGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('id.greaterThanOrEqual', <any>idGreaterThanOrEqual);
        }
        if (idIn) {
            idIn.forEach((element) => {
                queryParameters = queryParameters.append('id.in', <any>element);
            })
        }
        if (idLessThan !== undefined && idLessThan !== null) {
            queryParameters = queryParameters.set('id.lessThan', <any>idLessThan);
        }
        if (idLessThanOrEqual !== undefined && idLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('id.lessThanOrEqual', <any>idLessThanOrEqual);
        }
        if (idNotEquals !== undefined && idNotEquals !== null) {
            queryParameters = queryParameters.set('id.notEquals', <any>idNotEquals);
        }
        if (idSpecified !== undefined && idSpecified !== null) {
            queryParameters = queryParameters.set('id.specified', <any>idSpecified);
        }
        if (nameContains !== undefined && nameContains !== null) {
            queryParameters = queryParameters.set('name.contains', <any>nameContains);
        }
        if (nameDoesNotContain !== undefined && nameDoesNotContain !== null) {
            queryParameters = queryParameters.set('name.doesNotContain', <any>nameDoesNotContain);
        }
        if (nameEquals !== undefined && nameEquals !== null) {
            queryParameters = queryParameters.set('name.equals', <any>nameEquals);
        }
        if (nameIn) {
            nameIn.forEach((element) => {
                queryParameters = queryParameters.append('name.in', <any>element);
            })
        }
        if (nameNotEquals !== undefined && nameNotEquals !== null) {
            queryParameters = queryParameters.set('name.notEquals', <any>nameNotEquals);
        }
        if (nameSpecified !== undefined && nameSpecified !== null) {
            queryParameters = queryParameters.set('name.specified', <any>nameSpecified);
        }
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (size !== undefined && size !== null) {
            queryParameters = queryParameters.set('size', <any>size);
        }
        if (sort) {
            sort.forEach((element) => {
                queryParameters = queryParameters.append('sort', <any>element);
            })
        }
        if (userMembersIdEquals !== undefined && userMembersIdEquals !== null) {
            queryParameters = queryParameters.set('userMembersId.equals', <any>userMembersIdEquals);
        }
        if (userMembersIdGreaterThan !== undefined && userMembersIdGreaterThan !== null) {
            queryParameters = queryParameters.set('userMembersId.greaterThan', <any>userMembersIdGreaterThan);
        }
        if (userMembersIdGreaterThanOrEqual !== undefined && userMembersIdGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('userMembersId.greaterThanOrEqual', <any>userMembersIdGreaterThanOrEqual);
        }
        if (userMembersIdIn) {
            userMembersIdIn.forEach((element) => {
                queryParameters = queryParameters.append('userMembersId.in', <any>element);
            })
        }
        if (userMembersIdLessThan !== undefined && userMembersIdLessThan !== null) {
            queryParameters = queryParameters.set('userMembersId.lessThan', <any>userMembersIdLessThan);
        }
        if (userMembersIdLessThanOrEqual !== undefined && userMembersIdLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('userMembersId.lessThanOrEqual', <any>userMembersIdLessThanOrEqual);
        }
        if (userMembersIdNotEquals !== undefined && userMembersIdNotEquals !== null) {
            queryParameters = queryParameters.set('userMembersId.notEquals', <any>userMembersIdNotEquals);
        }
        if (userMembersIdSpecified !== undefined && userMembersIdSpecified !== null) {
            queryParameters = queryParameters.set('userMembersId.specified', <any>userMembersIdSpecified);
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ContextGroupDTO>>('get',`${this.basePath}/api/context-groups`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getContextGroup
     * 
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getContextGroupUsingGET(id: number, observe?: 'body', reportProgress?: boolean): Observable<ContextGroupDTO>;
    public getContextGroupUsingGET(id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ContextGroupDTO>>;
    public getContextGroupUsingGET(id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ContextGroupDTO>>;
    public getContextGroupUsingGET(id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getContextGroupUsingGET.');
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ContextGroupDTO>('get',`${this.basePath}/api/context-groups/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * updateContextGroup
     * 
     * @param body contextGroupDTO
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateContextGroupUsingPUT(body: ContextGroupDTO, observe?: 'body', reportProgress?: boolean): Observable<ContextGroupDTO>;
    public updateContextGroupUsingPUT(body: ContextGroupDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ContextGroupDTO>>;
    public updateContextGroupUsingPUT(body: ContextGroupDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ContextGroupDTO>>;
    public updateContextGroupUsingPUT(body: ContextGroupDTO, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateContextGroupUsingPUT.');
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ContextGroupDTO>('put',`${this.basePath}/api/context-groups`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
